<template>
  <div>
    <div
      class="w-section page-header blog-post-header"
      :style="backgroundImage('image')"
    >
      <div
        data-ix="navbar-grow"
        class="page-header-overlay blog-post"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="page-header-title"
          >
            {{ post.title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="w-section section article-container">
      <div class="w-container container with-fixed-block">
        <div class="dynamic-item-wrapper">
          <div
            class="dynamic-post-image"
            :style="backgroundImage('image')"
          />
          <div class="dynamic-item-content-block blog-author">
            <img
              data-w-expand="post-author"
              class="blog-author-image"
              :style="backgroundImage('author_image')"
            >
            <div
              data-w-expand="post-author"
              class="blog-author-title"
            >
              {{ post.author_name }}
            </div>
            <div
              data-w-expand="post-author"
              class="blog-author-title subtitle"
            >
              {{ post.author_title }}
            </div>
            <div class="blog-post-date-title">
              <strong>Written on</strong>:&nbsp;
            </div>
            <div class="blog-post-date-title">
              <BaseDate :date="post.published_at" />
            </div>
          </div>
          <div class="dynamic-item-content-block single-page">
            <div
              class="w-richtext"
              v-html="compiledMarkdown"
            >
              {{ compiledMarkdown }}
            </div>
          </div>
        </div>
        <div
          data-ix="show-fixed-block"
          class="fixed-block-container-wrapper"
        >
          <Sidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/TheSidebar'

export default {
  components: {
    Sidebar,
  },

  props: {
    post: {
      required: true,
      type: Object,
    },
  },

  computed: {
    compiledMarkdown() {
      return this.getMardownFile(this.post.content)
    },
  },

  methods: {
    getMardownFile(filename) {
      // eslint-disable-next-line
      console.log(require(`@/data/articles/${filename}`))
      return require(`@/data/articles/${filename}`)
    },
    backgroundImage(articleKey) {
      return {
        // eslint-disable-next-line
        'background-image': `url('${this.imagePath(articleKey)}')`,
      }
    },
    imagePath(articleKey) {
      let photo
      if (this.post) {
        // eslint-disable-next-line
        photo = require(`@/assets/article_photos/${this.post[articleKey]}`)
      }
      return photo
    },
  },
}
</script>
